<script lang="ts" setup>
const { $t } = useNuxtApp()
</script>

<template>
  <p class="fs-xsmall">
    {{ $t('Táto stránka je chránená systémom reCAPTCHA a platia na ňu') }}
    <a
      href="https://policies.google.com/privacy"
      class="text-decoration-underline"
      target="_blank"
    >
      {{ $t('zásady ochrany osobných údajov') }}
    </a>
    {{ $t('a') }}
    <a
      href="https://policies.google.com/terms"
      class="text-decoration-underline"
      target="_blank"
    >
      {{ $t('zmluvné podmienky') }}
    </a>
    {{ $t('spoločnosti Google.') }}
  </p>
</template>
